import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { QUERY_KEYS } from 'src/constants'

import { accountsService } from 'src/services/accounts.service'
import { IUpdateAccountAnalyticsDto } from 'src/types'

export const useUpdateAccountAnalytics = () => {
  const queryClient = useQueryClient()
  const { accountId } = useParams()

  return useMutation(
    async (dto: IUpdateAccountAnalyticsDto) =>
      accountId ? accountsService.updateAccountAnalytics(dto, accountId) : null,
    {
      onSuccess(data, vars) {
        if (!data) return

        // queryClient.setQueryData(
        //   [QUERY_KEYS.ACCOUNT, accountId],
        //   (prev?: IAccountByIdRespDto | null) => {
        //     console.log(prev, 'prev')
        //     console.log(prev, 'prev')

        //     return prev ? { ...prev, analytics_code: vars.analytics_code } : null
        //   },
        // )
        queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT, accountId])
      },
    },
  )
}
